import { graphql } from "react-relay";
import { SuggestionActionColors } from "../suggestion-action-colors";
import { SuggestionActionSlack } from "../suggestion-action-slack";
import { SuggestionActionTravelTime } from "../suggestion-action-travel-time";

export const suggestionActionConfigSettingsFragments = {
  org: graphql`
    fragment SuggestionActionConfigSettings_org on Org {
      ...SuggestionActionColors_org
      ...SuggestionActionSlack_org
      ...SuggestionActionTravelTime_org
    }
  `,
  payload: graphql`
    fragment SuggestionActionConfigSettings_payload on SuggestionActionConfigureSettingsPayload {
      configureSettingsType
    }
  `,
};
